<template>
  <ClientOnly>
    <ProductViewer
      v-if="showProductViewer && product"
      type="source"
      :raw-product="product"
      @load="iFrameMessages.postMessage.modelLoaded"
      @click:arButton="iFrameMessages.postMessage.arButtonClick"
      @click:stopImageTracker="iFrameMessages.postMessage.stopImageTrackerClick"
    />
  </ClientOnly>
</template>

<script setup lang="ts">
definePageMeta({
  layout: false
})

const { apiClient } = useApiClient()
const routeParams = useRouteParams<'source-product-sourceUrl'>()
const showProductViewer = ref(false)

// TODO: refactor when logic is fixed.
const productSource = computed(() => {
  const sourceUrl = routeParams.value.sourceUrl as string

  const url = atob(sourceUrl)
  // Temporary workaround for abrahamart
  if (url.includes('abrahamart') && url.includes('en/artwork')) {
    const parsedUrl = url.replace('en/artwork', 'kunstwerk')
    return btoa(parsedUrl)
  } else {
    return sourceUrl
  }
})

const iFrameMessages = {
  parentListener: ({ origin, data: { event, type } }: { origin: string; data: { type: string; event: string } }) => {
    if (origin !== window.location.origin && type === 'augmento-vendor-event') {
      if (event === 'loadModel') {
        console.log('loadModel:', origin, type, event)
        showProductViewer.value = true
      }
    }
  },
  postMessage: {
    modelLoaded: () => window.top?.postMessage({ event: 'modelLoaded' }, '*'),
    arButtonClick: () => window.top?.postMessage({ event: 'arButtonClick' }, '*'),
    isSourceValid: (value: boolean) => window.top?.postMessage({ event: 'isSourceValid', value }, '*'),
    stopImageTrackerClick: () => window.top?.postMessage({ event: 'stopImageTrackerClick' }, '*'),
    checkIsImageTarget: () => window.top?.postMessage({ event: 'checkIsImageTarget' }, '*')
  }
}

const { data: product } = await useAsyncData('sourceProduct', () => apiClient.get('/api/store/source', {
  params: {
    sourceUrl: productSource.value
  }
}))

if (product.value?.isImageTarget) {
  iFrameMessages.postMessage.checkIsImageTarget()
}

async function checkSourceValidity () {
  let isSourceValid = false

  try {
    await apiClient.get('/api/store/source/check', {
      params: {
        sourceUrl: productSource.value as string
      }
    })
    isSourceValid = true
  } catch {
    isSourceValid = false
  }

  iFrameMessages.postMessage.isSourceValid(!!isSourceValid)
}

onMounted(() => {
  window.addEventListener('message', iFrameMessages.parentListener)
  checkSourceValidity()
})

onBeforeUnmount(() => window.removeEventListener('message', iFrameMessages.parentListener))
</script>
